import { useScopedTranslate } from '@locale/translate';

export const translations = {
  en: {
    no_options: 'No more options',
    placeholder: 'Select...',
    loading: 'Loading...',
    result_count_one: '{count} result available',
    result_count_other: '{count} results available',
    clear: 'Clear',
    remove_option: 'Remove {label}',
    remove_option_confirm: 'Press Backspace again to remove {label}',
    option_selected: '{label}, selected',
    option_deselected: '{label}, deselected',
  },
  is: {
    no_options: 'Ekki fleiri valmöguleikar',
    placeholder: 'Velja...',
    loading: 'Hleður...',
    result_count_one: '{count} niðurstaða í boði',
    result_count_other: '{count} niðurstöður í boði',
    clear: 'Hreinsa',
    remove_option: 'Fjarlægja {label}',
    remove_option_confirm: 'Ýttu aftur á Bakka til að fjarlægja {label}',
    option_selected: '{label}, valið',
    option_deselected: '{label}, afvalið',
  },
  dk: {
    no_options: 'Ikke flere muligheder',
    placeholder: 'Vælg...',
    loading: 'Indlæser...',
    result_count_one: '{count} resultat tilgængeligt',
    result_count_other: '{count} resultater tilgængelige',
    clear: 'Ryd',
    remove_option: 'Fjern {label}',
    remove_option_confirm: 'Tryk på Backspace igen for at fjerne {label}',
    option_selected: '{label}, valgt',
    option_deselected: '{label}, fravalgt',
  },
};

export const useSelectTranslations = () => useScopedTranslate(translations);
